"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(Settings_1.default.api.testab, {
    post: {
        'testab.execute': '/:testId/execute?transactionRef=:transactionRef',
        'testab.convert': '/:testId/convert/:transactionRef'
    }
});
